import request from './request'

export const bug = (body) => {
  return request({
    method: 'POST',
    url: `/api/v1/bug`,
    body,
  })
}

export const bugPrivacy = (body) => {
  return request({
    method: 'POST',
    url: `/api/v1/bug/privacy`,
    body,
  })
}

export const getSecurityTypes = () => {
  return request({ url: `/api/v1/open/bug/security/types` })
}

export const getSecurityLevel = () => {
  return request({ url: `/api/v1/open/bug/security/levels` })
}

export const getPrivacyTypes = () => {
  return request({ url: `/api/v1/open/bug/privacy/types` })
}

export const getPrivacyLevel = () => {
  return request({ url: `/api/v1/open/bug/privacy/levels` })
}

export const getAppList = () => {
  return request({ url: `/api/v1/open/bug/privacy/apps` })
}

export const getChannels = () => {
  return request({ url: `/api/v1/open/bug/privacy/channels` })
}

export const uploadAttachment = (body) => {
  return request({
    url: `/api/v1/bug/file`,
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    body,
  })
}

export const uploadImage = (body) => {
  return request({
    url: `/api/v1/bug/image`,
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    body,
  })
}

export const getBugDetail = (id) => {
  return request({
    url: `/api/v1/bug/detail`,
    query: {
      id,
    },
  })
}

export const getBugStatus = (id) => {
  return request({
    url: `/api/v1/bug/status`,
    query: {
      id,
    },
  })
}

export const confirm = (id) => {
  return request({
    url: '/api/v1/bug/status',
    method: 'PATCH',
    query: {
      id,
    },
  })
}

export const getBugHistory = (id) => {
  return request({
    url: `/api/v1/bug/status/history`,
    query: {
      id,
    },
  })
}

export const getBugComments = (id) => {
  return request({
    url: `/api/v1/bug/comments`,
    query: {
      id,
    },
  })
}

export const submitMessage = ({ id, content, displayName, type }) => {
  return request({
    url: `/api/v1/bug/comment`,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: {
      bugId: id,
      content,
      type,
      displayName,
    },
  })
}
